<template>
  <div class="left-select">
    <div class="select-item" v-for="(lv1, index) in category" :key="lv1.id">
      <template v-if="lv1.categoryName.indexOf('接口文档') === -1">
        <div class="select-title">
          <div @click="toggle(lv1, 1)">{{lv1.categoryName}}</div>
          <i class="i-status" :class="{'el-icon-arrow-down': lv1.id == active.lv1 && !lv1_fold, 'el-icon-arrow-right': lv1.id != active.lv1 || lv1_fold}"></i>
        </div>
        <template v-if="!lv1_fold && active.lv1 && lv1.id == active.lv1">
          <div class="select-item" v-for="(lv2, index) in category2" :key="lv2.id">
            <div class="select-title second">
              <div @click="toggle(lv2, 2)" :class="{txt: lv1.show && deep == 3}">{{lv2.categoryName}}</div>
              <i class="i-status" :class="{'el-icon-arrow-down': lv2.id == active.lv2 && !lv2_fold, 'el-icon-arrow-right': lv2.id != active.lv2 || lv2_fold}"></i>
            </div>
            <template v-if="!lv2_fold &&active.lv2 && lv2.id == active.lv2">
              <div class="select-item" v-for="(lv3, index) in category3" :key="lv3.id">
                <div class="select-title third">
                  <div :class="{'txt': lv3.id == active.lv3}" @click="toggle(lv3, 3)">{{lv3.categoryName}}</div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </template>
      <a v-else class="select-title" style="display: block;" href="https://api.e.mi.com/doc.html#/home">▶  接口文档</a>
    </div>
  </div>
</template>
<script>
  import axios from 'common/axios.js';
  export default {
    name: 'doc-menu',
    data() {
      const query = this.$route.query;
      return {
        category: [],
        category2: [],
        category3: [],
        active: query,
        lv1_fold: false,
        lv2_fold: !query.lv3,
      }
    },
    watch: {
      '$route.query': function(query) {
        this.active = query;
        if(query.lv1) {
          this.getDocMenuList(query.lv1, 2);
        }else {
          this.category2 = [];
        }
        if(query.lv2) {
          this.getDocMenuList(query.lv2, 3);
        }else {
          this.category3 = [];
        }
      }
    },
    methods: {
      stringify(obj) {
        return Object.keys(obj).map(function (key) {
          const value = obj[key];
          if (value != null) {
            return key + "=" + encodeURIComponent(obj[key]);
          }
        }).filter(Boolean).join("&");
      },
      toggle(data, level) {
        const _active = Object.assign({}, this.active);
        if (level === 3) {
          _active.lv3 = data.id;
        } else if(level === 2) {
          _active.lv3 = null;
          if (data.id == this.active.lv2) {
            if(this.lv2_fold) {
              this.lv2_fold = false;
              this.getDocMenuList(data.id, 3);
            } else {
              this.lv2_fold = true;
            }
          } else {
            this.lv2_fold = false;
            this.getDocMenuList(data.id, 3);
            _active.lv2 = data.id;
          }
        } else if (level === 1) {
          _active.lv3 = null;
          _active.lv2 = null;
          if (data.id == this.active.lv1) {
            if (this.lv1_fold) {
              this.lv1_fold = false;
              this.getDocMenuList(data.id, 2);
            } else {
              this.lv1_fold = true;
            }
          } else {
            this.lv1_fold = false;
            this.getDocMenuList(data.id, 2);
            _active.lv1 = data.id;
          }
        }
        this.active = _active;
        this.setQuery();
      },
      setQuery() {
        location.hash = location.hash.replace(/\?.*$/g, '') + '?' + this.stringify(this.active);
      },
      async getDocMenuList(parentId, lv) {
        const {data: {result}} = await axios.get('/v2/openapi/doc/getCategoryList', {params: {parentId}});
        if (lv) {
          this['category' + lv] = result || [];
        } else {
          this.category = result || [];
          this.$emit('init', this.category[0] && this.category[0].id);
        }
      },
    },
    created() {
      this.getDocMenuList(0);
      let query = this.$route.query;
      if (query.lv1) {
        this.getDocMenuList(query.lv1, 2);
      }
      if (query.lv2) {
        this.getDocMenuList(query.lv2, 3);
      }
    }
  }
</script>
<style lang="scss">
  .left-select {
    border: 1px solid #ddd;
    background: #fff;
    overflow: hidden;
    overflow-y: auto;
    height: 100%;
    width: 310px;
    box-sizing: border-box;
    margin-right: 10px;
    flex-shrink: 0;
    .select-item .select-item .select-title {
      padding-left: 40px;
      &.third {
        padding-left: 60px;
      }
    }
    .select-title {
      background: #fff;
      height: 60px;
      line-height: 60px;
      padding-left: 20px;
      border-bottom: 1px dashed #dedede;
      position: relative;
      cursor: pointer;
      font-size: 16px;
      color:#191919;
      .txt{
        color: #ff6701;
      }
      .i-status{
        position : absolute;
        right : 10px;
        top : 20px;
      }
      &:hover {
        background-color: #f5f5f5;
      }
    }        
    .third {
      background-color: #fbfaf8;
      font-size: 14px;
      color:#666666;
      border-bottom: none;
    }
    .second {
      border-bottom: none;
      background-color: #fbfaf8;
      font-size: 14px;
      color:#666666;
    }
  }
</style>